<template>
  <div :class="{ box: true, shadow: !text }">
    <div class="text">
      <textarea class='autoExpand create-answer-textarea' @keydown.enter="prevent" @change="saveText" :placeholder="getPlaceholder" maxlength="350" spellcheck="false" v-model="text"></textarea>
    </div>
  </div>
</template>

<script>
import autosize from 'autosize'
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CreateAnswer',
  data() {
    return {
      text: ''
    }
  },
  methods: {
    ...mapActions('create', ['createAnswer']),
    prevent(event) {
      event.preventDefault();
      this.saveText();
    },
    saveText() {
      if(this.currentAnswers.length < 4) {
        this.createAnswer(this.text);
        this.text = '';
      }
    }
  },
  mounted() {
    autosize(document.querySelectorAll('textarea'));
  },
  computed: {
    ...mapGetters('create', ['currentAnswers']),
    getPlaceholder() {
      if(this.currentAnswers.length == 0) {
        return 'Add answer ...';
      } else {
        return 'Add alternative answer ...';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shadow {
  opacity: 0.8;
  transition: 0.3s;
  &:hover {
    opacity: 1;
  }
}

.box {
  width: 29rem;
  min-height: 6rem;
  display: flex;
  flex-direction: row;
  background-color: rgb(37, 38, 41);
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  @media (max-width: 1000px) {
    width: 100%;
  }

  .text {
    width: 100%;
    height: auto;
    background-color: #e6c17d;
    border-radius: 0.5rem;
    @media (max-width: 1000px) {
      width: 100%;
    }

    textarea {
      width: 100%;
      height: 100%;
      min-height: 6rem;
      background: none;
      border: none;
      text-align: center;
      font-size: 1.2rem;
      padding: 1rem;
      resize: none;
      outline: none;
      overflow: hidden;
      display: block;
      box-sizing: padding-box;
      &::placeholder {
        color: rgba(0, 0, 0, 0.616);
      }

      @media (max-width: 1000px) {
        font-size: 1rem;
      }
    }
  }
}
</style>